import Grid from '@mui/material/Grid';
import React, { memo } from 'react';


export const FlowNodeBody = memo(({ children, ...restProps }) => (
  <Grid item xs={12} padding='10px 5px' {...restProps}>
    {children}
  </Grid>
));
